import { get, indexOf, isArray, size } from 'lodash'
import React from 'react'
import { Radio } from 'semantic-ui-react'
import styled from 'styled-components'

const Wrapper = styled.div`
  // display: inline-block:
  margin-left: 25px;
  padding-top: 4px;
  // border: 1px solid lime;
`
type TSemanticRadio = {
  value?: boolean
  onChange?: (val: boolean) => void
  options?: any[]
}

const SemanticRadio = (props: TSemanticRadio): React.ReactElement => {
  const { value, onChange, options } = props

  const change = (): void => {
    if (isArray(options) && size(options) === 2) {
      // FIXME: not supported yet
      const index = indexOf(options, value) || 0

      if (onChange) {
        onChange(get(options, 1 - (index === -1 ? 0 : index)))
      }
    } else {
      if (onChange) {
        onChange(!value)
      }
    }
  }

  return (
    <Wrapper>
      <Radio toggle checked={value} onChange={change} />
    </Wrapper>
  )
}

export default SemanticRadio
